import { Pipe, PipeTransform } from '@angular/core';
import { Filter, FilterTypes, NumberFilter } from '@models/filter-types';

@Pipe({
    name: 'isNumberFilter',
    standalone: false,
})
export class IsNumberFilterPipe implements PipeTransform {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    transform(value: Filter<any>): value is NumberFilter {
        return value?.Type === FilterTypes.NumberFilterType;
    }
}
